<template>
  <div class="about-box">
    <div class="about-title-box">
      <span></span>法律声明
    </div>
    <div class="legal-dec-info-box">
      <h1 style="text-align: center;margin-bottom:30px">供应链企业信用管理平台法律声明</h1>
      <p>
        推进商务诚信建设是健全社会信用体系的重要内容，是完善市场经济体制的重要基础，是整顿和规范市场秩序的治本之策。为贯彻落实“商务诚信”建设，依据<b>《中华人民共和国招标投标法》《中华人民共和国政府采购法》《国务院关于建立完善守信联合激励和失信联合惩戒制度加快推进社会诚信建设的指导意见》《中共中央办公厅 国务院办公厅关于健全社会信用体系的意见》《推动商务信用体系建设高质量发展的指导意见》</b>等政策法规，供应链企业信用管理平台（简称平台）应运而生。平台通过制度化、数字化、标准化手段推进供应链企业信用生态建设，构建规范、透明的市场信用环境。平台所有权、经营权等法定权益归北京全民普惠信用管理有限公司所有。
      </p>
      <p>
        一、查询供应商企业信用信息的机构或个人在点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决的条款。如您对本协议有任何疑问，可向平台及运营主体咨询。
      </p>
      <p>
        二、查询信息的机构或个人按照注册页面提示填写信息、阅读并点击同意本协议且完成全部注册程序， 或以任何方式使用平台或接受服务即表示您已充分阅读、理解并同意接受本协议的条款和条件。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序并停止使用服务。
      </p>
      <p>
        三、供应链企业信用数据包含但不限于供应商、制造商、分销商、零售商和最终用户，以及物流、仓储、采购、生产、销售等上下游企业各类市场主体的遵守法规、守信履约、合规经营等方面的信用数据信息。包括基本信息、良好信息和不良信息。
      </p>
      <p>
        四、平台所汇集的信用数据信息均是属于违法、违规、违约、失信、许可、认可、认证等方面的信息。依据《全国公共信用信息基础目录》《全国失信惩戒措施基础清单》等法律法规，属于依法公开公示的信用信息，不涉及任何市场主体的隐私信息。
      </p>
      <p>
        五、任何机构、组织、个人在完成注册程序或其他平台允许的方式使用服务时，默认为已具备中华人民共和国法律规定的与其行为相适应的民事行为能力、资格及资质。
      </p>
      <p>
        六、任何机构、组织、个人依据本平台数据信息及信用报告所做出的任何决策、决定，所造成的任何结果，本平台均不法律责任、经济责任或其他连带责任。
      </p>
      <p>
        七、任何机构、组织、个人在使用本平台时，均需按平台规则支付相关服务费用。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LegalDeclaration"
}
</script>

<style scoped>

</style>
